import API from 'js/lib/api';

const itemFeedbackCountsAPI = API('/api/itemFeedbackCounts.v1', {
  type: 'rest',
});

export default itemFeedbackCountsAPI;
